import { action, observable, runInAction } from 'mobx';
import { servicePositionController } from './servicePositionController';
import {
  CreateServicePositionRequest,
  EditServicePositionRequest,
  GetServicePositionsRequest,
} from '../api/servicePositionApi';

// Полная позиция со всем строками
export interface ServicePosition {
  id: string,
  positionId: string,
  vendorCode?: string,
  positionName: string,
  classifier1RefName?: string,
  classifier2RefName?: string,
  classifier1RefId?: number,
  classifier2RefId?: number,
  basePrice: number,
}

export interface ServicePositionsStore {
  servicePositions: ServicePosition[],
  serviceId: string,
  error: any,
  currentServicePosition: ServicePosition,
  servicePositionsForSelector: ServicePosition[],
  servicePositionsForSelectorByServiceId: number,
}

export const servicePositionsStore: ServicePositionsStore = observable({
  servicePositions: [],
  serviceId: null,
  error: null,
  currentServicePosition: null,
} as ServicePositionsStore);

export const servicePositionsActions = {
  getServicePositions: async (request: GetServicePositionsRequest): Promise<void> => {
    const response = await servicePositionController.getServicePositions(request);
    servicePositionsActions.handleError(response);
    runInAction(() => {
      servicePositionsStore.servicePositions = response.data;
    });
  },

  getServicePositionFromList: async (id: string): Promise<void> => {
    const response = servicePositionsStore.servicePositions.find((v) => v.id === id);
    servicePositionsActions.setCurrentServicePosition(response || null);
  },

  createServicePosition: async (request: CreateServicePositionRequest): Promise<void> => {
    const response = await servicePositionController.createServicePosition(request);
    servicePositionsActions.handleError(response);
  },

  editServicePosition: async (id: string, request: EditServicePositionRequest): Promise<void> => {
    const response = await servicePositionController.editServicePosition(id, request);
    servicePositionsActions.handleError(response);
    servicePositionsActions.setCurrentServicePosition(response.data);
  },

  deleteServicePosition: async (id: string): Promise<void> => {
    const response = await servicePositionController.deleteServicePosition(id);
    servicePositionsActions.handleError(response);
  },

  clearCurrentPosition: action(() => {
    servicePositionsStore.currentServicePosition = null;
  }),

  clearError: action(() => {
    servicePositionsStore.error = null;
  }),

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      servicePositionsStore.error = errorData;
      throw errorData;
    }
  }),

  setCurrentServicePosition: action((servicePosition: ServicePosition) => {
     
    servicePositionsStore.currentServicePosition = servicePosition;
  }),

  getServicePositionsForSelector: async (request: GetServicePositionsRequest): Promise<void> => {
    const response = await servicePositionController.getServicePositions(request);
    servicePositionsActions.handleError(response);
    runInAction(() => {
      servicePositionsStore.servicePositionsForSelector = response.data;
      servicePositionsStore.servicePositionsForSelectorByServiceId = request.serviceId;
    });
  },

  clearCurrentPositionForSelector: action(() => {
    servicePositionsStore.servicePositionsForSelector = [];
    servicePositionsStore.servicePositionsForSelectorByServiceId = null;
  }),
};
